<template>
  <section id="integrations" class="integrations-section">
    <v-container class="section-container">
      <div class="section-header text-center">
        <span class="section-tag">Совместимость & Шлюзы</span>
        <h2 class="section-title">
          Бесшовная интеграция с вашей инфраструктурой
        </h2>
        <p class="section-description">
          OZO.direct моментально подключается к вашей кассовой системе,
          платежным шлюзам и курьерским службам. Меню, заказы и остатки
          синхронизируются автоматически.
        </p>
      </div>

      <!-- Лента 1: POS-системы и логистика (вправо) -->
      <div class="marquee-wrapper mt-10">
        <div class="marquee-track track-left">
          <div
            v-for="(partner, index) in repeatedPartners"
            :key="'p1-' + index"
            class="partner-card"
          >
            <i :class="['partner-icon', partner.icon]"></i>
            <div class="partner-info">
              <span class="partner-name">{{ partner.name }}</span>
              <span class="partner-type">{{ partner.type }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Лента 2: Платежи, технологии и платформы (влево) -->
      <div class="marquee-wrapper mt-4">
        <div class="marquee-track track-right">
          <div
            v-for="(tech, index) in repeatedTechs"
            :key="'t1-' + index"
            class="partner-card tech-card"
          >
            <i :class="['partner-icon', tech.icon]"></i>
            <div class="partner-info">
              <span class="partner-name">{{ tech.name }}</span>
              <span class="partner-type">{{ tech.type }}</span>
            </div>
          </div>
        </div>
      </div>
    </v-container>
  </section>
</template>

<script>
export default {
  name: "IntegrationsSection",
  data() {
    return {
      partners: [
        {
          name: "iiko",
          type: "Кассовая система & склад",
          icon: "ri-flashlight-fill",
        },
        {
          name: "r_keeper",
          type: "Автоматизация ресторана",
          icon: "ri-restaurant-2-fill",
        },
        {
          name: "Яндекс Доставка",
          type: "Курьерская логистика",
          icon: "ri-truck-fill",
        },
        {
          name: "1C: Предприятие",
          type: "Управленческий учет",
          icon: "ri-file-chart-fill",
        },
        {
          name: "Kaspi Pay & QR",
          type: "Платежи в приложении",
          icon: "ri-qr-code-fill",
        },
      ],
      techs: [
        {
          name: "Apple Pay",
          type: "Оплата в 1 касание",
          icon: "ri-apple-fill",
        },
        { name: "Google Pay", type: "Быстрый платеж", icon: "ri-google-fill" },
        {
          name: "Push Notifications",
          type: "Бесплатные рассылки",
          icon: "ri-notification-3-fill",
        },
        {
          name: "AI Translation Engine",
          type: "Перевод на 4 языка",
          icon: "ri-translate-2",
        },
        {
          name: "RFM Segmentation",
          type: "Автоматизация базы",
          icon: "ri-crosshair-2-fill",
        },
        {
          name: "Банковский эквайринг",
          type: "0% посредников",
          icon: "ri-bank-card-2-fill",
        },
      ],
    };
  },
  computed: {
    repeatedPartners() {
      return [...this.partners, ...this.partners, ...this.partners];
    },
    repeatedTechs() {
      return [...this.techs, ...this.techs, ...this.techs];
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/_variables.scss";

.integrations-section {
  background-color: $color-graphite-dark;
  color: $color-text-light;
  padding: $section-py 0;
  overflow: hidden;

  @media (max-width: 960px) {
    padding: $section-py-mobile 0;
  }
}

.section-container {
  max-width: $container-max-width;
  margin: 0 auto;
}

.section-tag {
  display: inline-block;
  color: $color-neon-green;
  background: rgba(0, 230, 118, 0.1);
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  padding: 6px 14px;
  border-radius: $radius-full;
  margin-bottom: 12px;
}

.section-title {
  font-family: $font-family-heading;
  font-size: 38px;
  font-weight: 800;
  color: $color-text-light;
  margin-bottom: 16px;

  @media (max-width: 960px) {
    font-size: 28px;
  }
}

.section-description {
  font-size: 16px;
  color: #94a3b8;
  max-width: 680px;
  margin: 0 auto;
  line-height: 1.6;
}

/* Dual Marquee Styles */
.marquee-wrapper {
  position: relative;
  width: 100%;
  overflow: hidden;
  mask-image: linear-gradient(
    to right,
    transparent 0%,
    black 10%,
    black 90%,
    transparent 100%
  );
  -webkit-mask-image: linear-gradient(
    to right,
    transparent 0%,
    black 10%,
    black 90%,
    transparent 100%
  );
}

.marquee-track {
  display: flex;
  gap: 20px;
  width: max-content;

  &:hover {
    animation-play-state: paused;
  }

  &.track-left {
    animation: marqueeLeft 32s linear infinite;
  }

  &.track-right {
    animation: marqueeRight 36s linear infinite;
  }
}

.partner-card {
  display: flex;
  align-items: center;
  gap: 14px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: $radius-md;
  padding: 14px 24px;
  white-space: nowrap;
  transition: all 0.25s ease;

  @media (max-width: 600px) {
    padding: 10px 16px;
    gap: 10px;
  }

  &:hover {
    background: rgba(255, 255, 255, 0.08);
    border-color: rgba(0, 230, 118, 0.4);
    transform: translateY(-2px);
  }

  .partner-icon {
    font-size: 22px;
    color: #00e676;
    display: flex;
    align-items: center;
    justify-content: center;

    @media (max-width: 600px) {
      font-size: 18px;
    }
  }

  .partner-info {
    display: flex;
    flex-direction: column;
  }

  .partner-name {
    font-family: $font-family-heading;
    font-weight: 700;
    font-size: 16px;
    color: #ffffff;

    @media (max-width: 600px) {
      font-size: 14px;
    }
  }

  .partner-type {
    font-size: 11px;
    color: #94a3b8;
  }

  &.tech-card {
    background: rgba(0, 230, 118, 0.03);
    border-color: rgba(0, 230, 118, 0.12);

    .partner-name {
      color: #f1f5f9;
    }
  }
}

@keyframes marqueeLeft {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(-33.333%);
  }
}

@keyframes marqueeRight {
  0% {
    transform: translateX(-33.333%);
  }
  100% {
    transform: translateX(0%);
  }
}
</style>
